import { ArrowUpRight, ShoppingBag, CalendarCheck } from 'lucide-react';
import { RESTAURANT } from '../constants/restaurant';

export const CtaPanels = () => {
  return (
    <section
      id="cta-panels"
      data-testid="cta-panels-section"
      className="relative bg-brand-cream py-20 md:py-28 px-6 md:px-12 lg:px-16"
    >
      <div className="max-w-7xl mx-auto grid lg:grid-cols-2 gap-6 md:gap-8">
        {/* Order Online */}
        <article
          id="order"
          data-testid="order-panel"
          className="relative overflow-hidden rounded-3xl bg-brand-burgundy text-brand-cream p-8 md:p-12 lg:p-14 min-h-[420px] flex flex-col justify-between group"
        >
          <div
            className="absolute inset-0 opacity-20 bg-cover bg-center mix-blend-overlay"
            style={{
              backgroundImage:
                "url('https://images.pexels.com/photos/30666774/pexels-photo-30666774.jpeg')",
            }}
          />
          <div className="absolute inset-0 grain-overlay" />
          <div className="relative">
            <ShoppingBag className="w-10 h-10 text-brand-gold mb-6" />
            <p className="text-[11px] uppercase tracking-[0.3em] text-brand-gold font-semibold">
              Quick &amp; Easy Takeaway
            </p>
            <h3 className="font-serif text-4xl md:text-5xl mt-3 leading-tight max-w-md">
              Craving Indian food at home?
            </h3>
            <p className="mt-5 text-brand-cream/85 max-w-md text-base md:text-lg leading-relaxed">
              Order your favourites online for quick and easy takeaway — packed hot, fresh
              and ready when you are.
            </p>
          </div>
          <a
            href={RESTAURANT.orderUrl}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="order-panel-btn"
            className="relative mt-10 inline-flex items-center justify-between gap-4 px-6 py-4 rounded-full bg-brand-cream text-brand-burgundy font-semibold text-xs tracking-[0.22em] uppercase w-fit hover:bg-brand-gold hover:text-brand-coffee transition-all duration-500 shadow-2xl"
          >
            Order Online
            <ArrowUpRight className="w-4 h-4 transition-transform group-hover:rotate-45" />
          </a>
        </article>

        {/* Book a Table */}
        <article
          id="book"
          data-testid="book-panel"
          className="relative overflow-hidden rounded-3xl bg-brand-coffee text-brand-cream p-8 md:p-12 lg:p-14 min-h-[420px] flex flex-col justify-between group"
        >
          <div
            className="absolute inset-0 opacity-25 bg-cover bg-center mix-blend-overlay"
            style={{
              backgroundImage:
                "url('https://images.pexels.com/photos/29707937/pexels-photo-29707937.jpeg')",
            }}
          />
          <div className="absolute inset-0 grain-overlay" />
          <div className="relative">
            <CalendarCheck className="w-10 h-10 text-brand-gold mb-6" />
            <p className="text-[11px] uppercase tracking-[0.3em] text-brand-gold font-semibold">
              Dine With Us
            </p>
            <h3 className="font-serif text-4xl md:text-5xl mt-3 leading-tight max-w-md">
              Family dinner, date night, or group meal?
            </h3>
            <p className="mt-5 text-brand-cream/80 max-w-md text-base md:text-lg leading-relaxed">
              Reserve your table online in just a few clicks. We&apos;ll keep the tandoor warm
              for you.
            </p>
          </div>
          <a
            href={RESTAURANT.bookUrl}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="book-panel-btn"
            className="relative mt-10 inline-flex items-center justify-between gap-4 px-6 py-4 rounded-full bg-brand-gold text-brand-coffee font-semibold text-xs tracking-[0.22em] uppercase w-fit hover:bg-brand-cream transition-all duration-500 shadow-2xl"
          >
            Book a Table
            <ArrowUpRight className="w-4 h-4 transition-transform group-hover:rotate-45" />
          </a>
        </article>
      </div>
    </section>
  );
};

export default CtaPanels;
